export default __webpack_public_path__ + "static/media/tfg-icon.a3416d6d.svg";